import React, {memo, useEffect, useState} from 'react'
import './index.scss'
import {useTranslation} from "react-i18next";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IModalBottomProps {
    title?: string
    defaultName?: string
    defaultVal?: string
    chooseArray: any[]
    onClose: () => void
    onConfirm: (name: string, val: string) => void
}

const ModalBottom: React.FunctionComponent<IModalBottomProps> = (props) => {
    const {t} = useTranslation();
    const {onClose, onConfirm, chooseArray, defaultName, defaultVal, title} = props
    const [chooseLst, setChooseLst] = useState<any[]>([])
    const [chooseInput, setChooseInput] = useState('')
    const [chooseName, setChooseName] = useState('')
    const [chooseVal, setChooseVal] = useState('')
    useEffect(() => {
        setChooseLst(chooseArray);
        if (defaultName && defaultVal) {
            setChooseName(defaultName)
            setChooseVal(defaultVal)
        } else {
            setChooseName('')
            setChooseVal('')
        }
    }, [setChooseLst, chooseArray, defaultName, defaultVal])

    const handleInput = (event: any) => {

        if (event.target.value) {
            const targetValue = event.target.value.toLowerCase()
            const fileterVal = targetValue.replace(targetValue[0],targetValue[0].toUpperCase())
            const filterData = chooseArray.filter((item: any) => item.name.indexOf(fileterVal) === 0)
            setChooseLst(filterData)
            setChooseInput(fileterVal)
            setChooseName('')
            setChooseVal('')
        } else {
            setChooseLst(chooseArray);
            setChooseName('')
            setChooseVal('')
            setChooseInput('')
        }
        // const filterData = countryStaticList.filter((item:any)=>item.name.indexOf(event.target.value.replace(event.target.value[0],event.target.value[0].toUpperCase())))
        // setCountryLst(filterData)
        // setCountryInput(event.target.value.replace(event.target.value[0],event.target.value[0].toUpperCase()))
    }
    const handleChoose = (obj: any) => {
        setChooseName(obj.name)
        setChooseVal(obj.value)
    }
    const handleConfirm = () => {
        if (chooseName && chooseVal) {
            onConfirm(chooseName, chooseVal)
        }

    }
    return (
        <div className='modal-bottom-content'>
            <div className="modal-bottom-overlay" onClick={() => onClose?.()}></div>
            <div className='content'>
                <header>
                    <div></div>
                    <p>{title}</p>
                    <img src={require('img/popup_close_icon.png').default} alt="" onClick={onClose}/>
                </header>
                <div className='child-content'>
                    <div className='input-content-bg'>
                        <div className='input-content'>
                            <input type="text" onChange={handleInput} placeholder={title}/>
                            <img src={require('img/popup_input_search_icon.png').default} alt=""/>
                        </div>
                    </div>

                    <ul>
                        {chooseLst.map((countryItem: any) => {

                            return <li key={countryItem.name}
                                       className={`${countryItem.name === chooseName && 'active'}`}
                                       onClick={() => handleChoose(countryItem)}><p
                                data-direction={chooseInput}>{countryItem.name}</p>{countryItem.name === chooseName &&
                            <img src={require('img/list_check_icon.png').default} alt=""/>}</li>
                        })}
                    </ul>
                </div>

                <div className='bottom-content'>
                    <div className='btn' onClick={() => handleConfirm()}>
                        <div>
                            {t('home.Confirm')}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default memo(ModalBottom)
